"use strict";
/**
 * huaxiang统计
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendJumpLogin = exports.sendHuaXiangStat_ListIndex = void 0;
var cookie_1 = __importDefault(require("../cookie"));
var user_1 = __importDefault(require("../user"));
/**
 * 发送画像统计，列表页的，统计第几页
 */
function sendHuaXiangStat_ListIndex(hash, index) {
    var uid = "";
    if (user_1.default.get() != null) {
        uid = user_1.default.get().id;
    }
    else {
        // var bid = "";
        if (cookie_1.default.get("qgqp_b_id")) {
            uid = cookie_1.default.get("qgqp_b_id");
        }
    }
    // send({
    //   type: "quote_list_index",
    //   page_hash: hash,
    //   quote_index: index,
    // });
    send({
        type: "quote_list_index",
        bVer: "all",
        userAgent: navigator.userAgent,
        uid: uid,
        protocol: index,
        domain: "quote.eastmoney.com",
        url: hash,
        isLoadImg: true,
    });
}
exports.sendHuaXiangStat_ListIndex = sendHuaXiangStat_ListIndex;
function send(json) {
    var st_pvi = "";
    if (cookie_1.default.get("st_pvi")) {
        st_pvi = cookie_1.default.get("st_pvi");
    }
    setTimeout(function () {
        json.domainId = self.location.host;
        json.st_pvi = st_pvi;
        json.emtj_pageId =
            window.emtj_pageId == undefined ? "" : window.emtj_pageId;
        var img = document.createElement("img");
        img.src =
            "//huaxiang.eastmoney.com/sw.png?json=" +
                encodeURIComponent(JSON.stringify(json));
        img.style.display = "none";
        document.body.appendChild(img);
        setTimeout(function () {
            document.body.removeChild(img);
        }, 2000);
    }, 100);
}
/**
 * 发送画像统计，跳到登录去
 */
function sendJumpLogin() {
    var uid = "";
    if (user_1.default.get() != null) {
        uid = user_1.default.get().id;
    }
    else {
        // var bid = "";
        if (cookie_1.default.get("qgqp_b_id")) {
            uid = cookie_1.default.get("qgqp_b_id");
        }
    }
    // send({
    //   type: "quote_list_index",
    //   page_hash: hash,
    //   quote_index: index,
    // });
    send({
        type: "quote_jump_login",
        bVer: "all",
        userAgent: navigator.userAgent,
        uid: uid,
        protocol: '',
        domain: "quote.eastmoney.com",
        url: '',
        isLoadImg: true,
    });
}
exports.sendJumpLogin = sendJumpLogin;
